import React  from "react";
import Grid from "@material-ui/core/Grid";
import MaterialTable from "material-table";
// Ust
import { useInvAF } from "../../../../St/Reviews/UseStyle";
// csG
import { stElemnt } from "../../../../St/Reviews/cStyle";

import { colors, Container, makeStyles, TextField, Typography } from "@material-ui/core";
import { useBody } from "../../invCompany/style";
import { txtA, txtE } from "../../../../Label/Lbl";
import  InvTotal  from "../../AFReadyDisigen/A4/InvTotal";
import { useRptAF } from "../../../../St/Reviews/UseStyle";
import { Rept } from "../../../../Context/InshData";
const BodyCar = (props) => {
  const cls = useRptAF();
  const {  data ,isFullPage,isLast,found, inv,sta} = props;

  const clas = useInvAF();
  const calssBody = useBody();
  const cellS = {

    padding: "0px 0px",
    textAlign: "-webkit-center",
    margin: "0px",
    whiteSpace: "normal",
    border: "solid 0.1px",
    fontSize: "0.7rem",
    width: "300px",
    fontFamily: "Amiri-Regular",
    fontWeight:"bold",
  };
  const locInv = JSON.parse(localStorage.getItem("datainv")) || {};
     
  var columns = [
    { title: "No \n م", field: "no" },
    //  { title:"Barcode \n الباركود", field: "barcode" },
     { title: "Service \n الخدمة", field: "symbol", cellStyle: cellS },
     { title:"Unit Name \n الوحدة", field: "unit_name" },

     {
       title: "Service Price \n سعر الخدمة",
       field:"new_exchange_price",
       
     },
     { title: "Qoantity \n الكمية ", field: "val1" },

     // { title: txtA.taxableAmount, field: "totBill" },
    //  { title:"Discount \n الخصم", field: "discount" },
     { title:"BeforeVat"+"\n"+ "الخاضع للضريبة", field: "totBill" },
     // { title: txtA.taxRate, field: "taxperc" },
     { title:"VatAmount \n مبلغ الضريبة", field: "taxval" },
     { title: "NetAmount \n شامل الضريبة", field: "tot_net_curr" },
   ];

  const data2 = data.map((row,i) => {
    return {
      ...row,
     id: i+1,
      totBill: row.new_exchange_price==row.exchange_price? row.totBill.toFixed(2) 
      :(row.tot_net_curr - (row.tot_net_curr / ((100 + row.taxperc) / row.taxperc))).toFixed(2),
      new_exchange_price: row.new_exchange_price==row.exchange_price? row.new_exchange_price.toFixed(2)
      :(row.new_exchange_price - (row.new_exchange_price / ((100 + row.taxperc) / row.taxperc))).toFixed(locInv?.NRound??4),
      tot_net_curr: row.tot_net_curr.toFixed(2),
      discount: row.discount.toFixed(2),

    };
  });

 

  return (
    <Grid item container className={cls.rootBdy}>
      <Grid item container //className={cls.rootBdyup}
      style={{paddingTop:"0.5rem" ,direction: "rtl"
        }}>
        <Grid
          item
          xs={12}
          style={{
           
          }}
        >
          <MaterialTable
            style={{ boxShadow: "none" }}
            // style={{direction:'ltr'}}
            options={{
              showTitle: false,
              toolbar: false,
              sorting: false,
              selection: false,
              // ToolBar Search
              searchFieldAlignment: "left",
              searchFieldVariant: "outlined",
              // ToolBar header
              showSelectAllCheckbox: false,
              showTextRowsSelected: false,
              pageSize: 5,
              paginationType: "stepped",
              showFirstLastPageButtons: false,

              headerStyle: {
                ...stElemnt.AF.header,
                backgroundColor: colors.grey[100],
                fontWeight: "bold",
                paddingTop: "2px",
                paddingBottom:"2px",
                border: "solid 0px",
                border: "solid 0.1px",
               
                
              },
              paging: false,
             // headerStyle: { ...stElemnt.AF.header, backgroundColor: "grey" },
              cellStyle: {
                ...stElemnt.AF.cell,
                padding: "0px 1px",
                // fontSize: 8,
              },
      
            }}
            localization={{ body: { emptyDataSourceMessage: <h1></h1> } }}
            columns={columns.map(column=>({
              ...column,
              title:column.title.split("\n").map((line,index)=>(
                <div key={index}>{line}</div>
              )),
             
            }))}
            data={data2}
          />
          {isLast && <InvTotal inv={inv} sta={sta}/>}
        </Grid>
        <Grid
                item
                container
                xs={12}
                style={{
                    fontFamily: "Amiri-Regular", paddingTop: "0.5rem",
                }}
            >
                <Grid item xs={6} style={{fontFamily: "Amiri-Regular", textAlign: "left", fontWeight:"bold", border: "solid 0.1px",  borderColor: "#fff"}}>
                    <TextField fullWidth variant="outlined" size="small"
                        id="refno"
                        inputProps={{ borderColor: "black", color:'red',fontWeight:"bold",fontSize:"0.9rem",fontFamily: "Amiri-Regular" }}
                        type="text"
                        name="notes"
                        multiline
                        value={found.Disc1_footer_ar}
                    />
                </Grid>

                <Grid item xs={6} style={{fontFamily: "Amiri-Regular",    fontWeight:"bold", textAlign: "left", border: "solid 0.1px", borderColor: "#fff" }}>
                    <TextField fullWidth variant="outlined" size="small"
                        id="refno"
                        inputProps={{  fontWeight:"bold",fontSize:"0.9rem",fontFamily: "Amiri-Regular" }}
                        type="text"
                        style={{fontFamily: "Amiri-Regular"}}
                        name="notes"
                        multiline
                        value={found.Disc1_footer_en}
                    />
                </Grid>


            </Grid>
      </Grid>
      
    </Grid>
  );
};

export default BodyCar;
